import type { ApiEntity } from '@backstage/catalog-model';
import { ApiBlueprint, createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  apiDocsConfigRef,
  defaultDefinitionWidgets,
} from '@backstage/plugin-api-docs';
import { crdApiWidget } from '@terasky/backstage-plugin-api-docs-module-crd';
import { grpcApiWidget } from '@samuel.fabel/plugin-grpc-docs';

/**
 * Owns the API Docs widget resolver for the NFS API Docs plugin.
 *
 * The API Docs page and routes remain provided by `apiDocsNfsPlugin`; this
 * override only composes the default, CRD, and gRPC definition widgets.
 * Keeping the resolver here gives `apiDocsConfigRef` one application owner.
 */
const apiDocsConfig = ApiBlueprint.makeWithOverrides({
  name: 'config',
  factory: originalFactory =>
    originalFactory(defineParams =>
      defineParams({
        api: apiDocsConfigRef,
        deps: {},
        factory: () => {
          const widgetByType = new Map(
            [...defaultDefinitionWidgets(), crdApiWidget, grpcApiWidget].map(
              widget => [widget.type, widget],
            ),
          );

          return {
            getApiDefinitionWidget: (apiEntity: ApiEntity) =>
              widgetByType.get(apiEntity.spec.type),
          };
        },
      }),
    ),
});

export const apiDocsModule = createFrontendModule({
  pluginId: 'api-docs',
  extensions: [apiDocsConfig],
});
